module.exports = __webpack_public_path__ + "static/split-ef2242f67a489ff9a6217a9efd65f861.png";